export default "__VITE_ASSET__X4vH72u$mwFBX7cSZJDOAw__"